<template>
  <div>
    <!-- Main Start -->
    <main class="main">
      <!-- Breadcrumb Start -->
      <!-- <div class="breadcrumb-wrap">
        <div class="banner">
          <img
            class="bg-img bg-top"
            src="/assets/images/inner-page/banner-p.jpg"
            alt="banner"
          />

          <div class="container-lg">
            <div class="breadcrumb-box">
              <div class="heading-box">
                <h1>User Dashboard</h1>
              </div>
              <ol class="breadcrumb">
                <li><a href="index.html">Home</a></li>

                <li>
                  <a href="javascript:void(0)"
                    ><i data-feather="chevron-right"></i
                  ></a>
                </li>

                <li class="current">
                  <a href="user-dashboard.html">User Dashboard</a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div> -->
      <!-- Breadcrumb End -->

      <!-- Dashboard Start -->
      <section class="user-dashboard">
        <div class="container-lg">
          <div class="row g-3 g-xl-4 tab-wrap">
            <div class="col-lg-4 col-xl-3 sticky">
              <button class="setting-menu btn-solid btn-sm d-lg-none">
                Menu <i class="arrow"></i>
              </button>
              <div class="side-bar">
                <span class="back-side d-lg-none">
                  <i data-feather="x"></i></span>
                <div class="profile-box">
                  <div class="img-box">
                    <img class="img-fluid" :src="avatar" alt="user" />
                    <div class="edit-btn">
                      <i data-feather="edit"></i>
                      <input class="updateimg"  type="file" name="img" />
                    </div>
                  </div>

                  <div class="user-name">
                    <h5>{{ fullname }}</h5>
                    <h6>{{ email }}</h6>
                  </div>
                </div>

                <ul class="nav nav-tabs nav-tabs2" id="myTab" role="tablist">
                  <!-- Órdenes: siempre visible -->
                  <li class="nav-item" role="presentation">
                    <button class="nav-link" :class="{ 'active': !this.perfil }" id="orders-tab" data-bs-toggle="tab"
                      data-bs-target="#orders" type="button" @click="scrollTop()" role="tab" aria-controls="orders"
                      aria-selected="false">
                      Ordenes
                      <span><i data-feather="chevron-right"></i></span>
                    </button>
                  </li>

                  <!-- Lista de deseos: solo usuarios logueados -->
                  <li class="nav-item" role="presentation" v-if="!isGuest">
                    <router-link to="/lista-deseos" class="nav-link">
                      Lista de deseos
                      <span><i data-feather="chevron-right"></i></span>
                    </router-link>
                  </li>

                  <!-- Direcciones: solo usuarios logueados -->
                  <li class="nav-item" role="presentation" v-if="!isGuest">
                    <button class="nav-link" id="savedAddress-tab" data-bs-toggle="tab" data-bs-target="#savedAddress"
                      type="button" role="tab" @click="scrollTop()" aria-controls="savedAddress" aria-selected="false">
                      Direcciones
                      <span><i data-feather="chevron-right"></i></span>
                    </button>
                  </li>

                  <!-- Perfil: solo usuarios logueados -->
                  <li class="nav-item" role="presentation" v-if="!isGuest">
                    <button class="nav-link" :class="{ 'active': this.perfil == 1 }" id="profile-tab"
                      data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" @click="scrollTop()"
                      aria-controls="profile" aria-selected="false">
                      Perfil
                      <span><i data-feather="chevron-right"></i></span>
                    </button>
                  </li>

                  <!-- Salir: solo usuarios logueados -->
                  <li class="nav-item" role="presentation" v-if="!isGuest">
                    <button class="nav-link" id="security-tab" data-bs-toggle="tab" data-bs-target="#security"
                      type="button" role="tab" aria-controls="security" aria-selected="false" @click="logout()">
                      Salir
                      <!-- <span><i data-feather="chevron-right"></i></span> -->
                    </button>
                  </li>
                </ul>

              </div>
            </div>

            <div class="col-lg-8 col-xl-9">
              <div class="right-content tab-content d-block" id="myTabContent">
                <!-- User Dashboard Start -->
                <div class="tab-pane" id="dashboard" role="tabpanel" aria-labelledby="dashboard-tab">
                  <div class="dashboard-tab">
                    <div class="title-box3">
                      <h3>Bienvenido</h3>

                    </div>

                    <div class="row g-0 option-wrap">
                      <div class="col-sm-6 col-xl-4">
                        <a href="javascript:void(0)" data-class="orders" class="tab-box">
                          <img src="/assets/icons/svg/1.svg" alt="shopping bag" />
                          <h5>Ordenes</h5>

                        </a>
                      </div>
                      <div class="col-sm-6 col-xl-4">
                        <a href="wishlist.html" data-class="wishlist" class="tab-box">
                          <img src="/assets/icons/svg/2.svg" alt="wishlist" />
                          <h5>Lista de deseos</h5>
                        </a>
                      </div>
                      <div class="col-sm-6 col-xl-4">
                        <a href="javascript:void(0)" data-class="savedAddress" class="tab-box">
                          <img src="/assets/icons/svg/3.svg" alt="address" />
                          <h5>Direcciones</h5>
                        </a>
                      </div>
                      <!-- <div class="col-sm-6 col-xl-4">
                        <a href="javascript:void(0)" data-class="payment" class="tab-box">
                          <img src="/assets/icons/svg/4.svg" alt="payment" />
                          <h5>Metodo de Pago</h5>
                        </a>
                      </div> -->
                      <div class="col-sm-6 col-xl-4">
                        <a href="javascript:void(0)" data-class="profile" class="tab-box">
                          <img src="/assets/icons/svg/5.svg" alt="profile" />
                          <h5>Perfil</h5>

                        </a>
                      </div>

                    </div>
                  </div>
                </div>
                <!-- User Dashboard End -->

                <!-- Order Tabs Start -->
                <div class="tab-pane " :class="{ 'show active': !this.perfil }" id="orders" role="tabpanel"
                  aria-labelledby="orders-tab">
                  <div class="cart-wrap order-content">
                    <div class="title-box3">
                      <h3>Mis Ordenes</h3>
                      <!-- <p>
                        H thanks for placing a delivery order with Oslo! Your
                        order should be home with you in soon
                      </p> -->
                    </div>

                    <div class="order-wraper" v-if="false">
                      <button class="btn-outline btn-sm my-2" @click="backList()">ATRAS</button>
                      <template v-for="(ITEM, index) in order_selected.items" :key="index">
                        <div class="order-box">
                          <div class="order-info">
                            <div class="product-details" data-productDetail="product-detail">
                              <div class="img-box">
                                <img :src="ITEM.imagen" alt="product" />
                              </div>
                              <div class="product-content">
                                <h5>
                                  <router-link :to="'/product/' + ITEM.slug">
                                    {{ ITEM.title }}
                                  </router-link>
                                </h5>
                                <p class="truncate-3">
                                  {{ ITEM.summary }}
                                </p>
                                <span>Total : <span>$ {{ ITEM.total }} </span></span>
                                <span>Cantidad : <span>{{ ITEM.quantity }}</span></span>
                                <span>Orden Id : <span>{{ order_selected.uniqd }}</span></span>
                              </div>
                            </div>

                            <div class="rating-box">
                              <span>
                                <a href="javascript:void(0)" class="btn-review" v-if="!ITEM.review"
                                  @click="openReviewModel(ITEM)" data-bs-toggle="modal" data-bs-target="#viewReview">
                                  Calificar producto
                                </a>
                              </span>
                              <ul class="rating p-0 mb" v-if="ITEM.review">
                                <li>
                                  <i :class="{ 'fill': ITEM.review.rating >= 1 }" data-feather="star"></i>
                                </li>
                                <li>
                                  <i :class="{ 'fill': ITEM.review.rating >= 2 }" data-feather="star"></i>
                                </li>
                                <li>
                                  <i :class="{ 'fill': ITEM.review.rating >= 3 }" data-feather="star"></i>
                                </li>
                                <li>
                                  <i :class="{ 'fill': ITEM.review.rating >= 4 }" data-feather="star"></i>
                                </li>
                                <li>
                                  <i :class="{ 'fill': ITEM.review.rating >= 5 }" data-feather="star"></i>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </template>

                    </div>

                    <div v-if="order_selected"
                      class="d-flex align-items-start align-items-sm-center justify-content-between title-box3">
                      <div>
                        <h3>Detalles de la orden</h3>
                      </div>
                      <button class="btn btn-outline btn-sm white-space-no" @click="backList()">Volver</button>
                    </div>

                    <div v-if="order_selected" class="order-detail-wrap order-content">
                      <div class="col-12">
                        <div class="order-summery-wrap mt-0 order-data">
                          <div class="banner-box">
                            <div class="media">
                              <div class="img">
                                <i data-feather="package"></i>
                              </div>
                              <div class="media-body">
                                <h2>ORDEN #{{ order_selected.order_id_external ? order_selected.order_id_external :
                                  order_selected.id }}
                                </h2>
                                <span class="">Estado: <span>{{ order_selected.status }}</span> | {{
                                  order_selected.created_at }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 mt-2 mb-2">

                        <div class="accordion">
                          <div class="accordion-item">
                            <h2 class="accordion-header">
                              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#fotos" aria-expanded="true" aria-controls="collapseOne">
                                Fotos
                              </button>
                            </h2>
                            <div id="fotos" class="accordion-collapse collapse" data-bs-parent="#fotos">
                              <div class="accordion-body text-white">


                                <div class="row row-cols-1 row-cols-lg-2 g-2 g-lg-3">

                                  <div class="col">
                                    <img :src="detalleEntrega.foto1" alt="" class="img-fluid">
                                  </div>

                                  <div class="col">
                                    <img :src="detalleEntrega.foto2" alt="" class="img-fluid">
                                  </div>

                                  <div class="col">
                                    <img :src="detalleEntrega.foto3" alt="" class="img-fluid">
                                  </div>

                                  <div class="col">
                                    <img :src="detalleEntrega.foto4" alt="" class="img-fluid">
                                  </div>

                                </div>

                              </div>
                            </div>
                          </div>
                          <div class="accordion-item" v-if="detalleEntrega.firma">
                            <h2 class="accordion-header">
                              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#firma" aria-expanded="true" aria-controls="collapseOne">
                                Firma
                              </button>
                            </h2>
                            <div id="firma" class="accordion-collapse collapse" data-bs-parent="#firma">
                              <div class="accordion-body text-white">


                                <img :src="detalleEntrega.firma" alt="" class="img-fluid">

                              </div>
                            </div>
                          </div>
                          <div class="accordion-item" v-if="detalleEntrega.nota">
                            <h2 class="accordion-header">
                              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                data-bs-target="#nota" aria-expanded="true" aria-controls="collapseOne">
                                Nota
                              </button>
                            </h2>
                            <div id="nota" class="accordion-collapse collapse" data-bs-parent="#nota">
                              <div class="accordion-body text-white">

                                {{ detalleEntrega.nota }}

                              </div>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="row g-0 option-wrap">
                        <div class="col-sm-6 col-xl-4 detail-box-user">
                          <div class="order-box">
                            <span class="pb-2"><span>Envío</span></span>
                            <template v-if="order_selected.type_entrega == 1">
                              <span>Sucursal</span>
                              <span>{{ order_selected.sucursal }} </span>
                            </template>
                            <template v-if="order_selected.type_entrega == 2">
                              <span>A domicilio </span>
                              <span>{{ order_selected.client_general ? order_selected.client_general.departament :
                                (order_selected.client_info.departament) }}</span>
                              <span>{{ order_selected.client_general ? order_selected.client_general.municipality :
                                (order_selected.client_info.municipality) }}</span>
                              <span>{{ order_selected.client_general ? order_selected.client_general.address :
                                (order_selected.client_info.address) }}</span>
                              <span>{{ order_selected.client_general ? order_selected.client_general.point_reference :
                                (order_selected.client_info.point_reference) }}</span>
                            </template>
                          </div>
                        </div>
                        <div class="col-sm-6 col-xl-4 detail-box-user">
                          <div class="order-box">
                            <span class="pb-2"><span>Método de pago</span></span>
                            <span style="white-space: pre-line">
                              <template v-if="order_selected.type_payment == 1">
                                Transferencia
                              </template>
                              <template v-if="order_selected.type_payment == 2">
                                <template v-if="order_selected.sel_type_pay == 1">
                                  Tarjeta (un solo pago)
                                </template>
                                <template v-else>
                                  Tarjeta a Cuotas (
                                    {{ 
                                      order_selected.sel_type_pay_cuotas == 5 ? 'Wompi cuotas' :
                                      order_selected.sel_type_pay_cuotas == 1 ? '3 cuotas' :
                                      order_selected.sel_type_pay_cuotas == 2 ? '6 cuotas' :
                                      order_selected.sel_type_pay_cuotas == 3 ? '9 cuotas' :
                                      order_selected.sel_type_pay_cuotas == 4 ? '12 cuotas' : '' 
                                    }}
                                    )
                                </template>
                                <template v-if="order_selected.bank_name">
                                  {{ order_selected.bank_name }}
                                </template>
                              </template>
                              <template v-if="order_selected.type_payment == 3">
                                PayPal
                              </template>
                              <template v-if="order_selected.type_payment == 4">
                                Contra-Entrega
                              </template>
                              <template v-if="order_selected.type_payment == 5">
                                Efectivo
                              </template>
                            </span>
                            <span v-if="order_selected.client_general.nit">NIT:<span>{{
                              order_selected.client_general.nit }}</span></span>
                            <span v-if="order_selected.client_general.nrc">NRC:<span>{{
                              order_selected.client_general.nrc }}</span></span>
                            <span v-if="order_selected.client_general.giro">Giro:<span>{{
                              order_selected.client_general.giro
                                }}</span></span>
                            <span class="pb-2 pt-2"><span>Nota: </span></span>
                            <span>{{ order_selected.client_general.description }}</span>
                          </div>
                        </div>
                        <div class="col-sm-6 col-xl-4 detail-box-user">
                          <div class="order-box">
                            <span class="pb-2"><span>Resumen</span></span>
                            <span>Subtotal:<span>$ {{ SUB_TOTAL_SUM.toFixed(2) }}</span></span>
                            <span>Descuento:<span>$ {{ DESCUENTO_TOTAL_SUM.toFixed(2) }}</span></span>
                            <span v-if="groups_coupons.length > 0">Cupon(es):
                              <template v-for="(item, index) in groups_coupons" :key="index">
                                <span><small>{{ item }}</small>
                                  <br></span>
                              </template>
                            </span>

                            <span>Envio:<span>$ {{ order_selected.tax }}</span></span>
                            <span v-if="order_selected.type_payment == 3">Comisión Paypal:<span>$ {{
                              order_selected.comision_paypal
                                }}</span></span>
                            <span>Total:<span>$ {{ order_selected.total }}</span></span>
                          </div>
                        </div>
                      </div>


                      <template v-for="sale_detail in order_selected.items" :key="sale_detail.id">
                        <div class="order-info">
                          <div class="product-details" data-productdetail="product-detail">
                            <div class="img-box">
                              <div class="product-details" data-productdetail="product-detail">
                                <div class="img-box"><img :src="sale_detail.imagen" alt="product"></div>
                                <div class="product-content">
                                  <h5>
                                    <router-link :to="'/product/' + sale_detail.slug">
                                      {{ sale_detail.title }}
                                    </router-link>
                                  </h5>
                                  <p class="truncate-2">
                                    {{ sale_detail.summary }}
                                  </p>

                                  <template v-if="hasValidDiscount(sale_detail)">
                                    <b class="color-oferta-cart">Oferta </b>
                                  </template>
                                  <template
                                    v-if="(!sale_detail.code_cupon && !sale_detail.code_discount && !sale_detail.code_offer) || (sale_detail.is_kit || sale_detail.is_pc_build)">
                                    Precio:
                                  </template>
                                  <span>${{ sale_detail.subtotal }}</span>

                                  <template v-if="hasValidDiscount(sale_detail)">
                                    <small class="sold-by"> Antes <del><span> $ {{ sale_detail.price_unit }}
                                        </span></del> </small>
                                  </template>

                                  <span>Cantidad: <span>{{ sale_detail.quantity }}</span></span>
                                  <span>Total: <span>$ {{ sale_detail.total }}</span></span>
                                </div>
                              </div>
                              <div class="rating-box">
                                <span v-if="sale_detail.review || !isGuest">Opciones :</span>

                                <ul class="rating p-0 mb" v-if="sale_detail.review">
                                  <li><i :class="{ 'fill': sale_detail.review.rating >= 1 }" data-feather="star"></i>
                                  </li>
                                  <li><i :class="{ 'fill': sale_detail.review.rating >= 2 }" data-feather="star"></i>
                                  </li>
                                  <li><i :class="{ 'fill': sale_detail.review.rating >= 3 }" data-feather="star"></i>
                                  </li>
                                  <li><i :class="{ 'fill': sale_detail.review.rating >= 4 }" data-feather="star"></i>
                                  </li>
                                  <li><i :class="{ 'fill': sale_detail.review.rating >= 5 }" data-feather="star"></i>
                                  </li>
                                </ul>

                                <a class="product-feedback" v-if="!isGuest && !sale_detail.review"
                                  @click="openReviewModel(sale_detail)" data-bs-toggle="modal"
                                  data-bs-target="#viewReview">
                                  Escribir recomendación
                                  <img class="feedback-icon" src="/assets/images/Nuevos/review.svg"
                                    alt="Escribir recomendación">
                                </a>

                                <a class="product-buyagain" v-if="!isGuest" href="javascript:void(0)"
                                  @click="OrderNew(sale_detail)">
                                  Ordenar de nuevo
                                  <img class="feedback-icon" src="/assets/images/Nuevos/repeat.svg"
                                    alt="Ordenar de nuevo">
                                </a>
                              </div>

                            </div>
                          </div>
                        </div>
                      </template>

                    </div>

                    <div class="order-wraper" v-if="!order_selected">
                      <div class="items-list">
                        <table class="table cart-table m-md-0">
                          <thead>
                            <tr>
                              <th class="">Orden</th>
                              <th class="">Fecha</th>
                              <th class="">Tipo de entrega</th>
                              <th class="">Método de pago</th>
                              <th class="">Estado</th>
                              <th class="">Total</th>
                              <th class="">Opciones</th>
                            </tr>
                          </thead>
                          <tbody class="t-body-orders">
                            <template v-if="myOrders_loading">
                              <tr>
                                <td colspan="7" class="text-center">
                                  <small>Cargando órdenes...</small>
                                </td>
                              </tr>
                            </template>

                            <template v-else-if="myOrders_error">
                              <tr>
                                <td colspan="7" class="text-center">
                                  <small class="text-danger">{{ myOrders_error }}</small>
                                </td>
                              </tr>
                            </template>

                            <template v-else>
                              <template v-for="(ORDER, index) in ORDERS" :key="index">
                                <tr style="cursor: pointer;">
                                  <td>
                                    <h6 class="title-color font-default2 text-nowrap">
                                      <small># {{ ORDER.order_id_external ? ORDER.order_id_external : ORDER.id }} </small>
                                    </h6>
                                  </td>
                                  <td class="detail text-nowrap"><small>{{ ORDER.created_at }}</small>
                                  </td>
                                  <td class="detail"><small>{{ ORDER.type_entrega == 1 ? 'Sucursal' : 'Domicilio'
                                  }}</small></td>

                                  <td class="detail"><small>{{ ORDER.type_payment == 1 ? 'Transferencia' : '' }} {{
                                    ORDER.type_payment == 2 ? 'Tarjeta' : '' }} {{ ORDER.type_payment == 3 ? 'PayPal' :
                                        '' }} {{ ORDER.type_payment == 4 ? 'Contra-Entrega' : '' }} {{ ORDER.type_payment ==
                                      5 ? 'Efectivo' : '' }}</small></td>

                                  <td class="detail">
                                    <small> <span class="badges badges-pill badges-theme">{{ ORDER.status }}</span>
                                    </small>
                                  </td>

                                  <td class="total text-nowrap">$ {{ ORDER.total }}</td>
                                  <td class="btn-color text-nowrap">
                                    <button class="btn btn-secondary btn-detail btn-sm" v-if="ORDER.type_entrega == 2">
                                      <router-link :to="trackingUrl(ORDER)" class="text-center"
                                        style="text-align: -webkit-center !important;">
                                        <img class="icon-perfil" width="64" height="64"
                                          src="/assets/images/tracking/orden-en-camino.png" alt="track-order" />
                                        <p>Tracking</p>
                                      </router-link>
                                    </button>

                                    <button class="btn btn-primary btn-detail btn-sm" @click="viewDetailSale(ORDER)">
                                      <img class="icon-perfil" width="64" height="64"
                                        src="/assets/images/Nuevos/order.svg" alt="todo-list--v1" />
                                      <p>Orden</p>
                                    </button>
                                  </td>
                                </tr>
                              </template>

                              <tr v-if="!ORDERS || ORDERS.length === 0">
                                <td colspan="7" class="text-center">
                                  <small>No hay órdenes.</small>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                          <tfoot v-if="!order_selected && !isGuest && ordersLastPage > 1">
  <tr>
    <td colspan="7">
      <div class="d-flex gap-2 align-items-center justify-content-end">
        <button class="btn btn-sm btn-outline" :disabled="ordersPage===1 || ordersLoading" @click="goToPage(1)">«</button>
        <button class="btn btn-sm btn-outline" :disabled="ordersPage===1 || ordersLoading" @click="prevPage()">‹</button>
        <span> Página {{ ordersPage }} / {{ ordersLastPage }} · {{ ordersTotal }} órdenes </span>
        <button class="btn btn-sm btn-outline" :disabled="ordersPage===ordersLastPage || ordersLoading" @click="nextPage()">›</button>
        <button class="btn btn-sm btn-outline" :disabled="ordersPage===ordersLastPage || ordersLoading" @click="goToPage(ordersLastPage)">»</button>
      </div>
    </td>
  </tr>
</tfoot>

                        </table>
                      </div>

                      <!-- Controles de paginación -->
                      <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-3" v-if="!isGuest">
                        

                        <div class="d-flex align-items-center gap-2">
                          <label class="me-1"><small>Límites:</small></label>
                          <select class="form-select form-select-sm w-auto"
                                  :value="myOrders_limit"
                                  @change="myOrders_setLimit($event.target.value)">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="30">30</option>
                            <option :value="40">40</option>
                          </select>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <!-- Order Tabs End -->

                <!-- Order Detail Tab Start -->
                <div class="tab-pane" id="orders-details" role="tabpanel" aria-labelledby="orders-details">
                  <div class="order-detail-wrap order-content">
                    <div class="row g-3 g-md-4">
                      <div class="col-12">
                        <div class="order-summery-wrap mt-0 order-data">
                          <div class="banner-box">
                            <div class="media">
                              <div class="img">
                                <i data-feather="package"></i>
                              </div>
                              <div class="media-body">
                                <h2>Order Delivered</h2>
                                <span class="font-sm">Delivered On July 15 2022</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="product-details">
                          <div class="img-box">
                            <img src="/assets/images/fashion/product/front/4.jpg" alt="product" />
                          </div>
                          <div class="product-content">
                            <h5>Women’s long sleeve Jacket</h5>
                            <p class="truncate-3">
                              Versatile sporty slogans short sleeve quirky laid
                              back orange lux hoodies vests pins badges.
                              Versatile sporty slogans short sleeve quirky laid
                              back orange lux hoodies vests pins badges. Cutting
                              edge crops stone transparent.
                            </p>
                            <span>Prize : <span>$120.00</span></span>
                            <span>Size : <span>M</span></span>
                            <span>Order Id : <span>edf125qa1d35</span></span>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="order-data summery-wrap">
                          <div class="order-summery-box">
                            <h5 class="cart-title">
                              Price Details (1 Quantity)
                            </h5>
                            <ul class="order-summery">
                              <li>
                                <span>Bag total</span>
                                <span>$220.00</span>
                              </li>

                              <li>
                                <span>Bag savings</span>
                                <span class="theme-color">-$20.00</span>
                              </li>

                              <li>
                                <span>Coupon Discount</span>
                                <a href="offer.html" class="font-danger">$120.00</a>
                              </li>

                              <li>
                                <span>Delivery</span>
                                <span>$50.00</span>
                              </li>

                              <li class="pb-0">
                                <span>Total Amount</span>
                                <span>$270.00</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="row gy-3 gy-sm-0 g-3 g-md-4">
                          <div class="col-sm-6">
                            <div class="order-data general-details">
                              <!-- Payment Method Start -->
                              <div class="payment-method mt-0">
                                <h5 class="cart-title">Payment Method</h5>
                                <div class="payment-box">
                                  <img src="/assets/icons/png/1.png" alt="card" />
                                  <span class="font-sm title-color">
                                    **** **** **** 6502</span>
                                </div>
                              </div>
                              <!-- Payment Method End -->

                              <button class="btn-solid mb-line btn-sm mt-4">
                                Get Invoice <i class="arrow"></i>
                              </button>
                            </div>
                          </div>

                          <div class="col-sm-6">
                            <div class="order-data general-details">
                              <!-- Contact Start -->
                              <div class="payment-method mt-0">
                                <h5 class="cart-title">Contact Us</h5>

                                <div class="payment-box">
                                  <i data-feather="phone"></i>
                                  <span class="font-sm title-color">
                                    <a class="content-color fw-500" href="tel:2554-4454-5646">2554-4454-5646</a>
                                  </span>
                                </div>

                                <div class="payment-box mt-3">
                                  <i data-feather="phone"></i>
                                  <span class="font-sm title-color">
                                    <a class="content-color fw-500" href="tel:5452-2545-2154">5452-2545-2154</a>
                                  </span>
                                </div>

                                <div class="payment-box mt-3">
                                  <i data-feather="mail"></i>
                                  <span class="font-sm title-color">
                                    <a class="content-color fw-500"
                                      href="mailto:someone@example.com">someone@example.com</a>
                                  </span>
                                </div>
                              </div>
                              <!-- Contact End -->
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12">
                        <div class="order-data general-details">
                          <!-- Address Section Start -->
                          <div class="address-ordered p-0">
                            <h5 class="cart-title">Order Address</h5>
                            <div class="address">
                              <h5 class="font-default title-color">
                                Nadine Vogt
                                <span class="badges badges-pill badges-theme">Home</span>
                              </h5>
                              <p class="font-default content-color">
                                <i data-feather="map-pin"></i> 1418 Riverwood
                                Drive, Suite 3245 Cottonwood, CA 96052, United
                                States
                              </p>
                            </div>
                          </div>
                          <!-- Address Section End -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Order Detail Tab End -->

                <!-- Saved Address Tabs Start -->
                <div class="tab-pane" id="savedAddress" role="tabpanel" aria-labelledby="savedAddress-tab">
                  <div class="address-tab">
                    <div class="title-box3">
                      <h3 v-if="new_address == 1">Todas las direcciones</h3>
                      <h3 v-if="new_address == 2">Registra una nueva dirección</h3>
                      <h3 v-if="new_address == 3">Actualizar dirección</h3>
                      <p>
                        Gestiona tus direcciones de envio
                      </p>
                    </div>

                    <div class="row g-3 g-md-4 custom-form form-pill">
                      <template v-if="new_address == 2 || new_address == 3">
                        <div class="col-6">
                          <div class="input-box1">
                            <label for="address">Nombre de la ubicación: (*)</label>
                            <input type="text" name="name_address" class="form-control" v-model="title"
                              placeholder="Nombre de la ubicación">
                          </div>
                        </div>
                        <div class="col-6">

                        </div>
                        <div class="col-6">
                          <div class="input-box1">
                            <label for="departamento">Departamento: (*)</label>
                            <select class="form-select form-control text-white" id="departamento"
                              @change="changeLocation" v-model="departament">
                              <option selected disabled value="">Selecciona...</option>
                              <template v-for="(DEPARTAMENTO, index) in S_DEPARTAMENTOS" :key="index">
                                <option :value="DEPARTAMENTO.name">{{ DEPARTAMENTO.name }}</option>
                              </template>
                            </select>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="municipio">Municipio: (*)</label>
                            <select class="form-select form-control text-white" id="municipio" v-model="municipality">
                              <option selected disabled value="">Choose...</option>
                              <template v-for="(MUNICIPIO, index) in S_MUNICIPIOS" :key="index">
                                <option :value="MUNICIPIO.city">{{ MUNICIPIO.city }}</option>
                              </template>
                            </select>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="comentarios">Dirección: (*)</label>
                            <textarea class="form-control text-white" placeholder="" style="height: 100px"
                              v-model="address"></textarea>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="comentarios">Punto de Referencia: </label>
                            <textarea class="form-control text-white" placeholder="" style="height: 100px"
                              v-model="point_reference"></textarea>
                          </div>
                        </div>

                        <div class="col-12 mb-30">
                          <div v-show="direccion_incorrecta">
                            <!--Alerta fuera de cobertura -->
                            <div class="alert-gps">
                              <img class="icon-alert-gps" src="/frontend/assets/images/cobertura-no-valida.png" alt="">
                              <p class="alert-novalido">Ubicación fuera de cobertura</p>
                            </div>
                            <p class="alert-mensaje">Si consideras que tu ubicación o zona no tiene cobertura por algún
                              error, puedes
                              contáctarnos por medio de whatsapp <a class="alert-link"
                                href="tel:79886164">7988-6164</a>. Seguiremos agregando
                              nuevas zonas de cobertura, manténte pendiente. </p>
                            <!-- End -->
                          </div>
                          <!--Alerta con cobertura -->
                          <div class="alert-gps" v-show="direccion_correcta">
                            <img class="icon-alert-gps" src="/frontend/assets/images/cobertura-valida.png" alt="">
                            <p class="alert-valido">Ubicación con cobertura </p>
                          </div>
                          <!-- End -->

                          <!--Alerta GPS apagado -->
                          <div v-show="mapa_error">
                            <div class="alert-gps">
                              <img class="icon-alert-gps" src="/frontend/assets/images/gps-off.png" alt="">
                              <p class="alert-apagado">Enciente tu GPS</p>
                            </div>
                            <p class="alert-mensaje">Enciende el GPS y actualiza la página para verificar si tenemos
                              cobertura en tu
                              ubicación.</p>
                          </div>
                          <!-- End -->
                          <!-- <p class="alert-valido">Permite acceder a la ubicación GPS de tu dispositivo. Actualiza la
                            página si es necesario
                            para obtener tu posición actual. Puedes ampliar el mapa y hacer clic para ajustar tu
                            ubicación según sea
                            necesario.</p>
                          <div class="google-map" ref="googleMap" style="height: 300px"></div> -->
                        </div>

                        <div class="col-6">
                          <div class="btn-box">
                            <button class="btn-outline btn-sm" @click="createAddress(1)">Regresar</button>
                            <button class="btn-solid btn-sm mx-3" type="button" @click="saveAddress()"
                              v-if="new_address == 2">
                              Guardar <i class="arrow"></i>
                            </button>
                            <button class="btn-solid btn-sm mx-3" type="button" @click="updateAddress()"
                              v-if="new_address == 3">
                              Guardar Cambios <i class="arrow"></i>
                            </button>
                          </div>
                        </div>
                      </template>
                      <template v-if="new_address == 1">
                        <template v-for="(ADDRE, index) in ADDRESS" :key="index">
                          <div class="col-md-6 col-lg-12 col-xl-6">
                            <!-- checked -->
                            <div class="address-box">
                              <div class="radio-box">
                                <div>
                                  <input class="radio-input" type="radio" :id="'radio' + index" name="radio1" />
                                  <label class="radio-label" :for="'radio' + index">{{ ADDRE.title }}</label>
                                </div>
                                <span class="badges badges-pill badges-theme">{{ index + 1 }}</span>
                                <div class="option-wrap">
                                  <span class="edit" @click="editAddress(ADDRE)"><img
                                      src="/assets/images/Nuevos/edit.svg"></span>
                                  <span class="delet ms-0" data-bs-toggle="modal" data-bs-target="#modalDeletePc"
                                    @click="selected_modal = ADDRE"><img src="/assets/images/Nuevos/delete.svg"></span>
                                </div>
                              </div>
                              <div class="address-detail">
                                <p class="content-color font-default">
                                  Dirección: {{ ADDRE.address }}
                                </p>
                                <p class="content-color font-default">
                                  Punto de referencia: {{ ADDRE.point_reference }}
                                </p>

                                <span class="content-color font-default">Departamento:
                                  <span class="font-default fw-500">
                                    {{ ADDRE.departament }}</span>
                                </span>

                                <span class="content-color font-default">Municipio:
                                  <span class="font-default fw-500">
                                    {{ ADDRE.municipality }}</span>
                                </span>
                              </div>
                            </div>
                          </div>
                        </template>

                        <div class="col-md-6 col-lg-12 col-xl-6">
                          <div
                            class="address-box add-new d-flex flex-column gap-2 align-items-center justify-content-center"
                            @click="createAddress(2)">
                            <span class="plus-icon"><i data-feather="plus"></i></span>
                            <h4 class="theme-color font-xl fw-500">
                              Agregar una nueva dirección
                            </h4>
                          </div>
                        </div>
                      </template>

                    </div>
                  </div>
                </div>
                <!-- Saved Address Tabs End -->

                <!-- Payment Tabs Start -->
                <div class="tab-pane" id="payment" role="tabpanel" aria-labelledby="payment-tab">
                  <div class="payment-tab">
                    <div class="d-flex align-items-start align-items-sm-center justify-content-between title-box3">
                      <div>
                        <h3>Your Saved Card</h3>
                        <p>
                          here is your saved card, from here you can easily add
                          or modify your card
                        </p>
                      </div>
                      <button class="btn btn-outline btn-sm white-space-no" data-bs-toggle="modal"
                        data-bs-target="#addNewcard">
                        Add Card
                      </button>
                    </div>

                    <div class="payment-section">
                      <div class="row g-3 g-xl-4">
                        <div class="col-sm-6 col-xl-4">
                          <div class="payment-card bg-theme-blue border-color-blue">
                            <div class="bank-info">
                              <img class="bank" src="/assets/icons/png/bank1.png" alt="bank1" />
                              <div class="card-type">
                                <img class="bank-card" src="/assets/icons/png/1.png" alt="card" />
                              </div>
                            </div>

                            <div class="card-details">
                              <span>Card Number</span>
                              <h5>6458 50XX XXXX 0851</h5>
                            </div>

                            <div class="card-details-wrap">
                              <div class="card-details">
                                <span>Name On Card</span>
                                <h5>Josephin water</h5>
                              </div>

                              <div class="text-center card-details">
                                <span>Validity</span>
                                <h5>XX/XX</h5>
                              </div>
                            </div>

                            <div class="btn-box">
                              <span data-bs-toggle="modal" data-bs-target="#editCard">
                                <i data-feather="edit"></i></span>
                              <span data-bs-toggle="modal" data-bs-target="#conformation"><i
                                  data-feather="trash"></i></span>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6 col-xl-4">
                          <div class="payment-card bg-theme-orange border-color-orange">
                            <div class="bank-info">
                              <img class="bank" src="/assets/icons/png/bank2.png" alt="bank1" />
                              <div class="card-type">
                                <img class="bank-card" src="/assets/icons/png/2.png" alt="card" />
                              </div>
                            </div>

                            <div class="card-details">
                              <span>Card Number</span>
                              <h5>2564 75XX XXXX 3545</h5>
                            </div>

                            <div class="card-details-wrap">
                              <div class="card-details">
                                <span>Name On Card</span>
                                <h5>Josephin water</h5>
                              </div>
                              <div class="text-center card-details">
                                <span>Validity</span>
                                <h5>XX/XX</h5>
                              </div>
                            </div>

                            <div class="btn-box">
                              <span data-bs-toggle="modal" data-bs-target="#editCard"><i data-feather="edit"></i></span>
                              <span data-bs-toggle="modal" data-bs-target="#conformation"><i
                                  data-feather="trash"></i></span>
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-6 col-xl-4">
                          <div class="payment-card bg-theme-yellow border-color-yellow">
                            <div class="bank-info">
                              <img class="bank" src="/assets/icons/png/bank3.png" alt="bank1" />
                              <div class="card-type">
                                <img class="bank-card" src="/assets/icons/png/5.png" alt="card" />
                              </div>
                            </div>

                            <div class="card-details">
                              <span>Card Number</span>
                              <h5>8564 34XX XXXX 9564</h5>
                            </div>

                            <div class="card-details-wrap">
                              <div class="card-details">
                                <span>Name On Card</span>
                                <h5>Josephin water</h5>
                              </div>
                              <div class="text-center card-details">
                                <span>Validity</span>
                                <h5>XX/XX</h5>
                              </div>
                            </div>

                            <div class="btn-box">
                              <span data-bs-toggle="modal" data-bs-target="#editCard"><i data-feather="edit">
                                </i></span>
                              <span data-bs-toggle="modal" data-bs-target="#conformation"><i
                                  data-feather="trash"></i></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Payment Tabs End -->

                <!-- Profile Tabs Start  show active-->
                <div class="tab-pane " :class="{ 'show active': this.perfil == 1 }" id="profile" role="tabpanel"
                  aria-labelledby="profile-tab">
                  <div class="profile">
                    <div class="title-box3">
                      <h3>Información Básica</h3>
                    </div>

                    <form action="javascript:void(0)" class="custom-form form-pill">
                      <div class="row g-3 g-xl-4">

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="name">Nombres: </label>
                            <input class="form-control" type="text" v-model="name" @input="onlyStringVarcharN"
                              name="name" id="name" />
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="name">Apellidos: </label>
                            <input class="form-control" type="text" v-model="surname" @input="onlyStringVarcharS"
                              name="surname" id="surname" />
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="input-box1">
                            <label for="email">Email:</label>
                            <input class="form-control" id="email" name="email" v-model="email" @input="setEmailP"
                              type="text" />
                          </div>
                        </div>

                 <div class="col-sm-4">
  <div class="input-box1">
    <label for="mobile">Celular:</label>
    <input 
      type="tel" 
      class="form-control" 
      id="mobile" 
      name="mobile" 
      v-model="mobile"
      @input="updateMaskPhone" 
      maxlength="8"
      placeholder="00000000" 
    />
  </div>
</div>

                        <div class="col-sm-4">
                          <label for="dui">DUI:</label>
                          <input maxlength="10" class="form-control" id="dui" name="dui" v-model="dui"
                            @input="applyMask" type="text" />
                        </div>

                        <div class="col-4">
                          <label for="mobile">Fecha de cumpleaños: </label>
                          <div class="input-box1 date" id="datepicker">
                            <input type="date" class="form-control" v-model="birthday" :max="max_year + '-12-31'"
                              id="date" />
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="input-box1">
                            <label for="photo">Foto de perfil: (jpg, jpeg, png y webp) 5MB</label>
                            <input class="form-control"  accept="image/jpg, image/png, image/webp, image/jpeg"
                             type="file" />
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="name">NIT:</label>
                            <input class="form-control" type="text" name="nit" v-model="nit"
                              placeholder="9999-999999-999-9" @input="updateMaskNit" />
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="name">NRC:</label>
                            <input class="form-control" type="text" name="nrc" placeholder="999999-9" v-model="nrc"
                              @input="updateMaskNrc" />
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="input-box1">
                            <label for="name">Giro:</label>
                            <input class="form-control" type="text" name="giro" v-model="gito" maxlength="256"
                              placeholder="" />
                          </div>
                        </div>

                        <div class="col-8">
                          <div class="message-alert message-alert-checkout" v-if="NIT_NRC_ERROR_TEXT">
                            <span class="close-button" @click="NIT_NRC_ERROR_TEXT = null">&times;</span>
                            <p> {{ NIT_NRC_ERROR_TEXT }}</p>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="input-group">
                            <label>Dirección de Facturación*
                            </label>
                          </div>
                          <div class="input-flex">
                            <div class="input-group">
                              <label>Departamento:</label>
                              <select id="dpto" name="departamento" @change="changeLocation"
                                v-model="departament_factura">
                                <option selected disabled value="">Selecciona...</option>
                                <template v-for="(DEPARTAMENTO, index) in S_DEPARTAMENTOS" :key="index">
                                  <option :value="DEPARTAMENTO.name">{{ DEPARTAMENTO.name }}</option>
                                </template>
                              </select>
                            </div>
                            <div class="input-group">
                              <label>Municipio:</label>
                              <select id="municipio" name="municipio" v-model="municipality_factura">
                                <option selected disabled value="">Choose...</option>
                                <template v-for="(MUNICIPIO, index) in S_MUNICIPIOS" :key="index">
                                  <option :value="MUNICIPIO.city">{{ MUNICIPIO.city }}</option>
                                </template>
                              </select>
                            </div>
                          </div>
                          <div class="input-group">
                            <label>Dirección Completa*
                            </label>
                            <input type="text" v-model="address_factura">
                          </div>
                        </div>
                      </div>

                      <div class="btn-box">
                        <button class="btn-outline btn-sm">Cancelar</button>
                        <button class="btn-solid btn-sm" type="button" @click="saveProfile()">
                          Guardar Cambios <i class="arrow"></i>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- Profile Tabs End -->

                <!-- Security Tabs Start -->
                <div class="tab-pane d-none" id="security" role="tabpanel" aria-labelledby="security-tab">
                  <div class="privacy-tab">
                    <div class="privacy box">
                      <div class="title-box3">
                        <h3>Privacy</h3>
                      </div>

                      <div class="setting-option">
                        <div class="content-box">
                          <h6 class="font-roboto">
                            Allows others to see my profile
                          </h6>
                          <p class="font-roboto">
                            all peoples will be able to see my profile.
                          </p>
                        </div>
                        <label class="switch">
                          <input checked type="checkbox" name="chk1" value="option1" class="setting-check" /><span
                            class="switch-state"></span>
                        </label>
                      </div>

                      <div class="setting-option mt-3">
                        <div class="content-box">
                          <h6 class="font-roboto">
                            Who has save this profile only that people see my
                            profile
                          </h6>
                          <p class="font-roboto">
                            all peoples will not be able to see my profile.
                          </p>
                        </div>
                        <label class="switch">
                          <input type="checkbox" name="chk2" value="option1" class="setting-check" /><span
                            class="switch-state"></span>
                        </label>
                      </div>

                      <button class="btn-solid btn-sm">
                        Save Changes <i class="arrow"></i>
                      </button>
                    </div>

                    <div class="account-box">
                      <div class="title-box3">
                        <h3>Account settings</h3>
                      </div>

                      <div class="setting-option">
                        <div class="content-box">
                          <h6 class="font-roboto">
                            Deleting Your Account Will Permanently
                          </h6>
                          <p class="font-roboto">
                            Once your account is deleted, you will be logged out
                            and will be unable to log in back.
                          </p>
                        </div>
                        <label class="switch">
                          <input type="checkbox" name="chk3" value="option2" class="setting-check" checked /><span
                            class="switch-state"></span>
                        </label>
                      </div>

                      <div class="setting-option mt-3">
                        <div class="content-box">
                          <h6 class="font-roboto">
                            Deleting Your Account Will Temporary
                          </h6>
                          <p class="font-roboto">
                            Once your account is deleted, you will be logged out
                            and you will be create new account.
                          </p>
                        </div>
                        <label class="switch">
                          <input type="checkbox" name="chk4" value="option4" class="setting-check" /><span
                            class="switch-state"></span>
                        </label>
                      </div>

                      <button class="btn-solid btn-sm">
                        Save Changes <i class="arrow"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Security Tabs End -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Dashboard End -->
    </main>
    <!-- Main End -->
    <!-- View Product Modal Start -->
    <div class="modal view-product fade" id="modalDeletePc" tabindex="-1" aria-labelledby="modalDeletePc"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content modal-sm" v-if="selected_modal" style="width: auto;">
          <div class="modal-header p-0">
            <span class="close-modal" data-bs-toggle="modal" data-bs-dismiss="modal"><i data-feather="x"></i></span>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <h5>
                  ¿Seguro que deseas eliminar la direccion "{{ selected_modal.title }}"?
                </h5>
              </div>
              <div class="col-12 d-flex my-3">
                <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-dismiss="modal"
                  @click="deleteAddress()">Eliminar</button>
                <button class="btn btn-light btn-sm mx-2" data-bs-toggle="modal"
                  data-bs-dismiss="modal">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- View Product Modal End -->
    <!-- use the modal component, pass in the prop -->
    <TrackingPedido :show="modalOpen" @close="modalOpen = false" @confirmation="modalOpen = false">
      <template #header>
        <h3>TRACKING DEL PEDIDO</h3>
      </template>
      <template #body>
        <p>Puedes ver el movimiento de tu pedido hasta la llegada en tus manos</p>
        <div class="cart-wrap">
          <div class="location-map" v-if="tacking_selected">
            <!-- height: 650px; -->
            <iframe class="map-iframe" :src="tacking_selected" style="width: 100%;height: 350px;"></iframe>
          </div>
        </div>
      </template>
    </TrackingPedido>

    <TrackingPedido :show="modalEntrega" @close="modalEntrega = false" @confirmation="modalEntrega = false">
      <template #header>
        <h3>TRACKING DEL PEDIDO</h3>
      </template>
      <template #body>
        <p>Puedes ver el movimiento de tu pedido hasta la llegada en tus manos</p>
        <div class="container py-5 tracking d-none d-sm-block">
          <div class=" mb-3">
            <div class="">
              <div
                class="steps d-flex flex-wrap flex-sm-nowrap justify-content-between padding-top-2x padding-bottom-1x">
                <div class="step completed">
                  <div class="step-icon-wrap">
                    <div class="step-icon"><img src="https://i.imgur.com/9nnc9Et.png" class="img-responsive"
                        alt="order-placed" /></div>
                  </div>
                  <h4 class="step-title">Orden Pendiente<span> <br>2023/09/13 10:17 AM</span></h4>
                </div>
                <div class="step completed">
                  <div class="step-icon-wrap">
                    <div class="step-icon"><img src="/assets/images/tracking/recibido.svg" class="img-responsive"
                        alt="order-placed" /></div>
                  </div>
                  <h4 class="step-title">Orden recibido<span> <br>09 Aug 2021, 10:30am</span></h4>
                </div>
                <div class="step">
                  <div class="step-icon-wrap">
                    <div class="step-icon"><img src="https://i.imgur.com/TkPm63y.png" class="img-responsive"
                        alt="order-placed" /></div>
                  </div>
                  <h4 class="step-title">Orden en camino<span> <br>09 Aug 2021, 12:00pm</span></h4>
                </div>
                <div class="step">
                  <div class="step-icon-wrap">
                    <div class="step-icon"><img src="/assets/images/tracking/house.svg" class="img-responsive"
                        alt="order-placed" /></div>
                  </div>
                  <h4 class="step-title">Orden entregado<span><br>2023/09/13 02:06 PM</span></h4>
                </div>
              </div>
            </div>
          </div>
          <div class="mapa-tracking">
            <div class="google-map" v-if="!isMobile()" ref="googleMap" style="height: 300px"></div>
          </div>
        </div>
        <div class="container py-5 tracking d-block d-sm-none">
          <div class="">
            <div class="mapa-tracking">
              <div class="google-map" v-if="isMobile()" ref="googleMap" style="height: 300px"></div>
            </div>
            <div class="">
              <div id="tracking-pre"></div>
              <div id="tracking">
                <div class="tracking-list">
                  <div class="tracking-item">
                    <div class="tracking-icon status-intransit">
                      <svg class="svg-inline--fa fa-circle fa-w-16" aria-hidden="true" data-prefix="fas"
                        data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                        data-fa-i2svg="">
                        <path fill="currentColor"
                          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                      </svg>
                    </div>
                    <div class="tracking-date"><img src="https://i.imgur.com/9nnc9Et.png" class="img-responsive"
                        alt="order-placed" /></div>
                    <div class="tracking-content">Orden Pendiente<span>2023/09/13 10:17 AM</span></div>
                  </div>
                  <div class="tracking-item">
                    <div class="tracking-icon status-intransit">
                      <svg class="svg-inline--fa fa-circle fa-w-16" aria-hidden="true" data-prefix="fas"
                        data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                        data-fa-i2svg="">
                        <path fill="currentColor"
                          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                      </svg>
                    </div>
                    <div class="tracking-date"><img src="/assets/images/tracking/recibido.svg" class="img-responsive"
                        alt="order-placed" /></div>
                    <div class="tracking-content">Orden recibido<span>09 Aug 2021, 10:30am</span></div>
                  </div>
                  <div class="tracking-item">
                    <div class="tracking-icon status-current blinker">
                      <svg class="svg-inline--fa fa-circle fa-w-16" aria-hidden="true" data-prefix="fas"
                        data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                        data-fa-i2svg="">
                        <path fill="currentColor"
                          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                      </svg>
                    </div>
                    <div class="tracking-date"><img src="https://i.imgur.com/TkPm63y.png" class="img-responsive"
                        alt="order-placed" /></div>
                    <div class="tracking-content">Orden en camino<span>09 Aug 2021, 12:00pm</span></div>
                  </div>
                  <div class="tracking-item-pending">
                    <div class="tracking-icon status-intransit">
                      <svg class="svg-inline--fa fa-circle fa-w-16" aria-hidden="true" data-prefix="fas"
                        data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                        data-fa-i2svg="">
                        <path fill="currentColor"
                          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"></path>
                      </svg>
                    </div>
                    <div class="tracking-date"><img src="/assets/images/tracking/house.svg" class="img-responsive"
                        alt="order-placed" /></div>
                    <div class="tracking-content">Orden entregado<span>2023/09/13 02:06 PM</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </TrackingPedido>
  </div>
</template>

<script>
import SALVADOR from '../../assets/js/salvador'
import myApi from '../../plugins/axios'
import GoogleMapsApiLoader from 'google-maps-api-loader'
import TrackingPedido from './modal/TrackingPedido.vue'
import store from '../../plugins/store'
import CartResource from '../../resource/cart'

export default {
  name: 'ProfileClient',

  components: { TrackingPedido },

  data () {
    return {
      // sesión / visual
      isGuest: false,
      avatar: '/assets/images/avatar/avatar.jpg',
      perfil: 1,

      // catálogo SV
      S_MUNICIPIOS: [],
      BACKUP_MUNICIPIOS: [],
      S_DEPARTAMENTOS: [],

      // perfil
      fullname: null,
      name: null,
      surname: null,
      email: null,
      mobile: null,
      nit: null,
      nrc: null,
      dui: null,
      title: null,
      gito: null,
      departament: null,
      municipality: null,
      address: null,
      point_reference: null,
      birthday: null,
      photo_file: null,

      // órdenes y detalle
      ORDERS: [],
      CARTS: [],
      order_selected: null,

      // paginación (solo usuarios logueados)
      ordersLoading: false,
      ordersPage: 1,
      ordersPerPage: 10,
      ordersLastPage: 1,
      ordersTotal: 0,

      // direcciones
      new_address: 1,
      ADDRESS: [],
      ADDRES_SELECTED: null,

      // MAPS
      mapa_error: false,
      direccion_correcta: false,
      direccion_incorrecta: false,
      google: null,
      map: null,
      marker: null,
      latitud: 0,
      longitud: 0,
      referencia: null,
      numDeltas: 50,
      delay: 5,
      i: 0,

      // modales tracking
      modalOpen: false,
      tacking_selected: null,
      modalEntrega: false,

      // facturación
      departament_factura: null,
      municipality_factura: null,
      address_factura: null,
      NIT_NRC_ERROR_TEXT: null,

      // query params
      uniqd_parms: null,
      t_parms: null,

      selected_modal: null,

      // totales de detalle
      SUB_TOTAL_SUM: 0,
      DESCUENTO_TOTAL_SUM: 0,
      groups_coupons: [],

      PHONE_ERROR_TEXT: null,
      max_year: 0,

      // entrega (fotos/firma/nota)
      detalleEntrega: {
        foto1: '',
        foto2: '',
        foto3: '',
        foto4: '',
        firma: '',
        nota: ''
      },

      // —— Estados para el bloque de paginación “myOrders_*” del template ——
      myOrders_loading: false,
      myOrders_error: null
    }
  },

  computed: {
    // Mapeos para que el bloque inferior de paginación use los mismos datos
    myOrders_page () { return this.ordersPage },
    myOrders_totalPages () { return this.ordersLastPage },
    myOrders_limit () { return this.ordersPerPage },
    myOrders_hasPrev () { return this.ordersPage > 1 },
    myOrders_hasNext () { return this.ordersPage < this.ordersLastPage }
  },

  methods: {
    // ————————————————————————
    // Helpers
    // ————————————————————————
    hasValidDiscount (item) {
      return (
        item.discount > 0 &&
        (item.code_cupon || item.code_discount || item.code_offer) &&
        !item.is_kit &&
        !item.is_pc_build
      )
    },

    isMobile () {
      return (window.innerWidth || screen.width) <= 767
    },

    trackingUrl (order) {
      const base = `/tracking-pedido/${order.uniqd}`
      const t = (this.t_parms || '').trim()
      return t ? `${base}?t=${encodeURIComponent(t)}` : base
    },

    // ————————————————————————
    // Auth / Logout
    // ————————————————————————
    async logout () {
      localStorage.removeItem('carts')
      localStorage.removeItem('carts_item_cache')
      await store.dispatch('logout')
      await this.$router.replace('/')
      window.location.reload()
    },

    // ————————————————————————
    // Paginación de órdenes (logueado)
    // ————————————————————————
  // ————————————————————————
// Paginación de órdenes (logueado)
// ————————————————————————
async fetchOrders (page = 1) {
  if (this.isGuest) return
  try {
    this.ordersLoading = true
    this.myOrders_loading = true
    this.myOrders_error = null

    const pageNum = Number(page) || 1
    const perPageNum = Number(this.ordersPerPage) || 10

    // Enviamos page también en query por si el backend solo lee querystring
    const { data } = await myApi.post(
      'ecommerce/show_profile',
      { page: pageNum, per_page: perPageNum, limit: perPageNum },
      { params: { page: pageNum, per_page: perPageNum, limit: perPageNum } }
    )

    // PERFIL: solo si viene en la respuesta (típico en página 1)
    if (data && Object.prototype.hasOwnProperty.call(data, 'client') && data.client) {
      const c = data.client || {}
      this.name                 = c.name               ?? this.name
      this.surname              = c.surname            ?? this.surname
      this.email                = c.email              ?? this.email
      this.mobile               = c.mobile             ?? this.mobile
      this.nit                  = c.nit                ?? this.nit
      this.nrc                  = c.nrc                ?? this.nrc
      this.gito                 = c.gito               ?? this.gito
      this.dui                  = c.dui                ?? this.dui
      this.birthday             = c.birthday           ?? this.birthday
      this.departament_factura  = c.departament        ?? this.departament_factura
      this.municipality_factura = c.municipality       ?? this.municipality_factura
      this.address_factura      = c.address_f          ?? this.address_factura
      this.fullname             = c.full_name          ?? this.fullname
      this.avatar               = c.avatar             ?? this.avatar
      this.ADDRESS              = Array.isArray(c.address) ? c.address : this.ADDRESS

      if (this.departament_factura) {
        this.changeLocation({ target: { value: this.departament_factura } })
      }
    }

    // ÓRDENES + paginación (multiformato + fallback en cliente)
    const pg = data?.orders ?? []
    const norm = this.normalizeOrdersPagination(pg, pageNum, perPageNum)

    this.ORDERS         = norm.rows
    this.ordersPage     = norm.currentPage
    this.ordersPerPage  = norm.perPage
    this.ordersTotal    = norm.total
    this.ordersLastPage = norm.lastPage

    // Feather
    const script2 = document.createElement('script')
    script2.src = '../../assets/js/feather/feather.min.js'
    document.body.appendChild(script2)
  } catch (e) {
    this.myOrders_error = 'No pudimos cargar tus órdenes.'
    this.$notify({
      title: 'ÓRDENES',
      text: 'No pudimos cargar tus órdenes.',
      type: 'error',
      duration: 4000
    })
  } finally {
    this.ordersLoading = false
    this.myOrders_loading = false
  }
},

// ---- Helper robusto como MÉTODO (no function suelta) ----
normalizeOrdersPagination (pg, pageNum, perPageNum) {
  let rows = []
  let currentPage = Number(pageNum) || 1
  let perPage     = Number(perPageNum) || 10
  let total       = 0
  let lastPage    = 1

  // 1) Array plano -> SIN meta: fallback de paginación en cliente
  if (Array.isArray(pg)) {
    total = pg.length
    lastPage = Math.max(1, Math.ceil(total / perPage))
    const start = (currentPage - 1) * perPage
    const end   = start + perPage
    rows = pg.slice(start, end)
    return { rows, currentPage, perPage, total, lastPage }
  }

  // 2) { data:[...], meta:{...} } (Laravel API Resources)
  if (pg && Array.isArray(pg.data) && pg.meta) {
    rows        = pg.data
    currentPage = Number(pg.meta.current_page ?? currentPage)
    perPage     = Number(pg.meta.per_page ?? perPage)
    total       = Number(pg.meta.total ?? rows.length)
    lastPage    = Number(pg.meta.last_page ?? 1)
    return { rows, currentPage, perPage, total, lastPage }
  }

  // 3) { data:[...] } sin meta (fallback cliente)
  if (pg && Array.isArray(pg.data)) {
    total = pg.data.length
    lastPage = Math.max(1, Math.ceil(total / perPage))
    const start = (currentPage - 1) * perPage
    const end   = start + perPage
    rows = pg.data.slice(start, end)
    return { rows, currentPage, perPage, total, lastPage }
  }

  // 4) Variante simple {current_page, per_page, total, last_page, data:[...]}
  if (pg && Array.isArray(pg.data)) {
    rows        = pg.data
    currentPage = Number(pg.current_page ?? currentPage)
    perPage     = Number(pg.per_page ?? perPage)
    total       = Number(pg.total ?? rows.length)
    lastPage    = Number(pg.last_page ?? Math.max(1, Math.ceil(total / perPage)))
    return { rows, currentPage, perPage, total, lastPage }
  }

  // 5) { results:[...], page, per_page, total, last_page }
  if (pg && Array.isArray(pg.results)) {
    rows        = pg.results
    currentPage = Number(pg.page ?? currentPage)
    perPage     = Number(pg.per_page ?? perPage)
    total       = Number(pg.total ?? rows.length)
    lastPage    = Number(pg.last_page ?? Math.max(1, Math.ceil(total / perPage)))
    return { rows, currentPage, perPage, total, lastPage }
  }

  // 6) Cualquier otro caso
  return { rows: [], currentPage, perPage, total: 0, lastPage: 1 }
},











    goToPage (p) {
      if (p < 1 || p > this.ordersLastPage || this.ordersLoading) return
      this.order_selected = null
      this.fetchOrders(p)
      this.scrollTop()
    },
    nextPage () { this.goToPage(this.ordersPage + 1) },
    prevPage () { this.goToPage(this.ordersPage - 1) },

    // ————————————————————————
    // Enlaces para el bloque “myOrders_*” del template (sin tocar el template)
    // ————————————————————————
    myOrders_prevPage () {
      if (!this.myOrders_hasPrev || this.myOrders_loading) return
      this.goToPage(this.ordersPage - 1)
    },
    myOrders_nextPage () {
      if (!this.myOrders_hasNext || this.myOrders_loading) return
      this.goToPage(this.ordersPage + 1)
    },
    myOrders_setLimit (val) {
      const parsed = parseInt(val, 10)
      if (!parsed || parsed <= 0) return
      this.ordersPerPage = parsed
      // Reiniciamos a la página 1 con el nuevo límite
      this.goToPage(1)
    },

    // ————————————————————————
    // Invitado: carga una sola orden por uniqd + token t
    // ————————————————————————
    async loadGuestOrder (uniqd) {
      try {
        const t = (this.$route.query.t || '').toString().trim()
        const { data } = await myApi.get(
          `ecommerce/order_show/${encodeURIComponent(uniqd)}`,
          t ? { params: { t } } : undefined
        )

        const ORDER = data.order

        // Sidebar invitado
        const cg = ORDER?.client_general || ORDER?.client_guest || {}
        this.fullname = cg.full_name || 'Invitado'
        this.email = cg.email || ''
        this.avatar = this.avatar || '/assets/images/avatar/avatar.jpg'

        // Lista de órdenes: solo una
        this.ORDERS = [ORDER]
        this.order_selected = null

        // Paginación bloqueada (1/1)
        this.ordersPage = 1
        this.ordersLastPage = 1
        this.ordersTotal = 1
        this.ordersPerPage = 1

        // Totales para la vista de detalle si se abre
        this.DESCUENTO_TOTAL_SUM = 0
        this.SUB_TOTAL_SUM = 0
        this.groups_coupons = []

        ORDER.items.forEach(cart => {
          const priceUnit = Number(cart.price_unit || 0)
          const subtotal = Number(cart.subtotal || 0)
          const qty = Number(cart.quantity || 0)
          const discount = Number(cart.discount || 0)

          if (discount > 0) this.DESCUENTO_TOTAL_SUM += (priceUnit - subtotal)
          this.SUB_TOTAL_SUM += (priceUnit * qty)

          if (cart.code_cupon && !this.groups_coupons.includes(cart.code_cupon)) {
            this.groups_coupons.push(cart.code_cupon)
          }
        })

        const script = document.createElement('script')
        script.src = '../../assets/js/feather/feather.min.js'
        document.body.appendChild(script)
      } catch (e) {
        this.$notify({
          title: 'INVITADO',
          text: 'No pudimos cargar la orden. Abre nuevamente el enlace del correo.',
          type: 'error',
          duration: 4000
        })
      }
    },

    // ————————————————————————
    // Acciones de órdenes
    // ————————————————————————
    viewDetailSale (ORDER) {
      this.order_selected = ORDER
      this.DESCUENTO_TOTAL_SUM = 0
      this.SUB_TOTAL_SUM = 0
      this.groups_coupons = []

      this.order_selected.items.forEach(cart => {
        if (cart.discount > 0) {
          this.DESCUENTO_TOTAL_SUM += (cart.price_unit - cart.subtotal)
        }
        this.SUB_TOTAL_SUM += (cart.price_unit * cart.quantity)

        if (cart.code_cupon && !this.groups_coupons.includes(cart.code_cupon)) {
          this.groups_coupons.push(cart.code_cupon)
        }
      })

      const script2 = document.createElement('script')
      script2.src = '../../assets/js/feather/feather.min.js'
      document.body.appendChild(script2)

      this.viewDetailEntrega(ORDER)
    },

    backList () {
      this.order_selected = null
      // si estamos en logueado, nos mantenemos en la página actual
    },

    async OrderNew (sale_detail) {
      const resp = await myApi.post('ecommerce/order_new_detail', {
        sale_detail_id: sale_detail.id
      })
      if (resp.data.message === 403) {
        this.$notify({
          title: resp.data.message_text,
          duration: 3500,
          type: 'error'
        })
      } else {
        this.addCart(resp.data.product)
        setTimeout(() => {
          this.$router.push({ name: 'CartShop' })
        }, 100)
      }
    },

    trackingInfo (ORDER) {
      // abre la ruta de tracking (ya soportas invitado con ?t)
      window.open(process.env.VUE_APP_FRONTED + `tracking-pedido/${ORDER.uniqd}`, '')
    },

    // ————————————————————————
    // Entrega: fotos/firma/nota
    // ————————————————————————
    async viewDetailEntrega (orden) {
      const resp = await myApi.post('ecommerce/orders/detalle_comprobante', {
        orden: orden.order_id_external
      })
      if (resp.data) {
        let { photo1, photo2, photo3, photo4, firma, nota } = resp.data
        const url = process.env.VUE_APP_BACKEND_NODE

        const trim1 = s => String(s || '').substring(1)

        this.detalleEntrega.foto1 = `${url}${trim1(photo1)}`
        this.detalleEntrega.foto2 = `${url}${trim1(photo2)}`
        this.detalleEntrega.foto3 = `${url}${trim1(photo3)}`
        this.detalleEntrega.foto4 = `${url}${trim1(photo4)}`
        this.detalleEntrega.firma = `${url}${trim1(firma)}`
        this.detalleEntrega.nota = nota || ''
      }
    },

    // ————————————————————————
    // Carrito
    // ————————————————————————
    addCart (PRODUCT_SELECTED = null) {
      const CARTS = this.CARTS
      this.ERROR_TEXT = null
      CartResource.add(
        CARTS,
        (!PRODUCT_SELECTED ? this.product_selected : PRODUCT_SELECTED),
        this.emitter,
        this.$notify,
        this.$cookies,
        this.quantity
      )
    },

    // ————————————————————————
    // Direcciones
    // ————————————————————————
    createAddress (val) {
      this.new_address = val
      // if (this.new_address === 2 || this.new_address === 3) this.initGoogleMap()

      this.ADDRES_SELECTED = null
      this.departament = null
      this.municipality = null
      this.address = null
      this.point_reference = null
      this.title = null

      setTimeout(() => {
        const script2 = document.createElement('script')
        script2.src = '../../assets/js/feather/feather.min.js'
        document.body.appendChild(script2)
        this.scrollTop()
      }, 50)
    },

    editAddress (ADDRE) {
      this.new_address = 3
      this.departament = ADDRE.departament
      this.municipality = ADDRE.municipality
      this.address = ADDRE.address
      this.point_reference = ADDRE.point_reference
      this.ADDRES_SELECTED = ADDRE
      this.title = ADDRE.title

      // this.initGoogleMap()

      setTimeout(() => {
        if (ADDRE.latitud) {
          this.latitud = Number(ADDRE.latitud)
          this.longitud = Number(ADDRE.longitud)
          // this.initializeMap(this.latitud, this.longitud)
        }
      }, 50)

      this.changeLocation({ target: { value: this.departament } })
    },

    async updateAddress () {
      try {
        if (this.title.replace(/\s+/g, '').length === 0) {
          this.$notify({ text: 'NECESITAS INGRESAR UN NOMBRE A LA DIRECCIÓN', duration: 4000, type: 'error' })
          return
        }
        if (!this.departament || !this.municipality || !this.address || !this.title) {
          this.$notify({ title: 'VALIDACIÓN', text: 'TODOS LOS CAMPOS SON NECESARIOS', duration: 4000, type: 'error' })
          return
        }
        const data = {
          latitud: this.latitud,
          longitud: this.longitud,
          departament: this.departament,
          municipality: this.municipality,
          address: this.address,
          point_reference: this.point_reference,
          title: this.title
        }
        const resp = await myApi.put('ecommerce/profile_address/' + this.ADDRES_SELECTED.id, data)
        const INDEX = this.ADDRESS.findIndex(item => item.id === this.ADDRES_SELECTED.id)
        this.ADDRESS[INDEX] = resp.data.address
        this.$notify({ title: 'SE REGISTRO LOS CAMBIOS DE LA DIRECCIÓN A SU PANEL', duration: 4000, type: 'success' })
        this.scrollTop()
        this.createAddress(1)
      } catch (error) {
        this.$notify({
          title: 'VALIDACIÓN',
          text: 'HUBO UN ERROR A NIVEL INTERNO, PORFAVOR COMUNICARSE CON SU PROVEEDOR',
          duration: 4000,
          type: 'error'
        })
      }
    },

    async saveAddress () {
      try {
        if (this.title.replace(/\s+/g, '').length === 0) {
          this.$notify({ text: 'NECESITAS INGRESAR UN NOMBRE A LA DIRECCIÓN', duration: 4000, type: 'error' })
          return
        }
        if (!this.departament || !this.municipality || !this.address || !this.title) {
          this.$notify({ text: 'TODOS LOS CAMPOS SON NECESARIOS', duration: 4000, type: 'error' })
          return
        }
        const data = {
          latitud: this.latitud,
          longitud: this.longitud,
          departament: this.departament,
          municipality: this.municipality,
          address: this.address,
          point_reference: this.point_reference,
          title: this.title
        }
        const resp = await myApi.post('ecommerce/profile_address', data)
        this.ADDRESS.push(resp.data.address)
        this.$notify({ title: 'SE AGREGO UNA NUEVA DIRECCIÓN A SU PANEL', duration: 4000, type: 'success' })
        this.title = null
        this.departament = null
        this.municipality = null
        this.address = null
        this.point_reference = null
        this.scrollTop()
        this.createAddress(1)
      } catch (error) {
        this.$notify({
          title: 'VALIDACIÓN',
          text: 'HUBO UN ERROR A NIVEL INTERNO, PORFAVOR COMUNICARSE CON SU PROVEEDOR',
          duration: 4000,
          type: 'error'
        })
      }
    },

    async deleteAddress () {
      try {
        await myApi.delete('ecommerce/profile_address/' + this.selected_modal.id)
        const INDEX = this.ADDRESS.findIndex(item => item.id === this.selected_modal.id)
        if (INDEX !== -1) this.ADDRESS.splice(INDEX, 1)
        this.$notify({ title: 'SE ELIMINO LA DIRECCIÓN DE SU PANEL', duration: 4000, type: 'success' })
        this.scrollTop()
      } catch (error) {
        this.$notify({
          title: 'VALIDACIÓN',
          text: 'HUBO UN ERROR A NIVEL INTERNO, PORFAVOR COMUNICARSE CON SU PROVEEDOR',
          duration: 4000,
          type: 'error'
        })
      }
    },

    changeLocation (event) {
      const MUNICIPIO_SELECTED = event.target.value
      this.S_MUNICIPIOS = this.BACKUP_MUNICIPIOS.filter(item => item.state === MUNICIPIO_SELECTED)
    },

    // ————————————————————————
    // Subida foto rápida
    // ————————————————————————
    validateFile (fileInput) {
      const allowedExtensions = /\.(jpg|jpeg|png|webp)$/i
      const maxSizeInBytes = 5 * 1024 * 1024
      if (!fileInput.files || !fileInput.files.length) return false
      const file = fileInput.files[0]
      if (!allowedExtensions.test(file.name)) return false
      if (file.size > maxSizeInBytes) return false
      return true
    },
    onFileChange (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      if (!this.validateFile(e.target)) {
        this.$notify({ title: 'Extensiones permitidas: jpg, jpeg, png, webp (5MB).', duration: 4000, type: 'error' })
        return
      }
      this.photo_file = files[0]
    },
    async onFileChangeFast (e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      if (!this.validateFile(e.target)) {
        this.$notify({ title: 'Extensiones permitidas: jpg, jpeg, png, webp (5MB).', duration: 4000, type: 'error' })
        return
      }
      this.photo_file = files[0]
      const formData = new FormData()
      formData.append('photo_file', this.photo_file)
      const resp = await myApi.post('ecommerce/profile', formData)
      if (resp.data.error) {
        for (const key in resp.data.error) {
          this.$notify({ title: resp.data.error[key], duration: 4000, type: 'error' })
        }
      } else {
        this.showProfile(this.ordersPage)
        this.photo_file = null
        this.$notify({ title: 'La foto se actualizó correctamente', duration: 3500 })
      }
    },

    // ————————————————————————
    // Perfil
    // ————————————————————————
    async showProfile (page = 1) {
      // Reutilizamos fetchOrders para mantener la paginación consistente
      await this.fetchOrders(page)

      // Si venías con ?uniqd=XYZ en la URL, autoabrir detalle de esa orden
      setTimeout(() => {
        if (this.uniqd_parms && Array.isArray(this.ORDERS)) {
          const sale = this.ORDERS.find(s => s.uniqd === this.uniqd_parms)
          if (sale) this.viewDetailSale(sale)
        }
      }, 50)
    },

    // ————————————————————————
    // Review / utilidades UI
    // ————————————————————————
    openReviewModel (ITEM) {
      this.emitter.emit('review-detail-modal', ITEM)
    },
    scrollTop () {
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50)
    },

    // ————————————————————————
    // Google Maps
    // ————————————————————————
    initializeMap (lat, lng) {
      const mapContainer = this.$refs.googleMap
      this.map = new this.google.maps.Map(mapContainer, {
        center: { lat, lng },
        gestureHandling: 'greedy',
        zoom: 16
      })
      const icon2 = {
        url: '/assets/logos/servicio-al-cliente.png',
        scaledSize: new this.google.maps.Size(50, 50)
      }
      this.marker = new this.google.maps.Marker({
        position: { lat, lng },
        map: this.map,
        title: `Latitude:${lat} | Longitude:${lng}`,
        icon: icon2
      })

      const result = { lat, lng }
      const geocoder = new this.google.maps.Geocoder()
      geocoder.geocode({ location: result }, (results, status) => {
        if (status === 'OK' && results[0]) {
          if (this.new_address !== 3) {
            this.address = results[0].formatted_address
            const parts = this.address.split(',')
            if (parts.length > 2) this.changeForMunicipio(parts[parts.length - 2])
          }
        }
      })

      this.map.addListener('click', (mapsMouseEvent) => {
        const _lat = Number(mapsMouseEvent.latLng.lat().toString())
        const _lng = Number(mapsMouseEvent.latLng.lng().toString())
        const r = { lat: _lat, lng: _lng }
        this.efecto(r)
        this.direccion_correcta = true

        const geocoder2 = new this.google.maps.Geocoder()
        geocoder2.geocode({ location: r }, (results, status) => {
          if (status === 'OK' && results[0] && this.new_address !== 3) {
            this.address = results[0].formatted_address
            const parts = this.address.split(',')
            if (parts.length > 2) this.changeForMunicipio(parts[parts.length - 2])
          }
        })
      })
    },

    efecto (result) {
      this.i = 0
      this.deltaLat = (result.lat - this.latitud) / this.numDeltas
      this.deltaLng = (result.lng - this.longitud) / this.numDeltas
      this.moveMarker()
    },
    moveMarker () {
      this.latitud += this.deltaLat
      this.longitud += this.deltaLng
      this.marker.setTitle(`Latitude:${this.latitud} | Longitude:${this.longitud}`)
      this.marker.setPosition({ lat: this.latitud, lng: this.longitud })
      if (this.i !== this.numDeltas) {
        this.i++
        setTimeout(this.moveMarker, this.delay)
      }
    },
    changeForMunicipio (municipio) {
      const DEPARTAMENTO = this.BACKUP_MUNICIPIOS.filter(item => item.city === municipio.trim())
      if (DEPARTAMENTO.length > 0) {
        this.departament = DEPARTAMENTO[0].state
        this.municipality = municipio.trim()
        this.changeLocation({ target: { value: DEPARTAMENTO[0].state } })
      }
    },

    async initGoogleMap () {
      const googleMapApi = await GoogleMapsApiLoader({ apiKey: 'AIzaSyA6MRhgLWpKf7XfNNUP3H9yz-ts9R3hvD8' })
      this.google = googleMapApi
      const onError = () => { this.mapa_error = true }
      const onSuccess = (geo) => {
        this.latitud = Number(geo.coords.latitude)
        this.longitud = Number(geo.coords.longitude)
        this.mapa_error = false
        this.initializeMap(this.latitud, this.longitud)
      }
      if (!navigator.geolocation) onError()
      else navigator.geolocation.getCurrentPosition(onSuccess, onError)
    },

    async initGoogleMapEntrega (ORDER = null) {
      const googleMapApi = await GoogleMapsApiLoader({ apiKey: 'AIzaSyA6MRhgLWpKf7XfNNUP3H9yz-ts9R3hvD8' })
      this.google = googleMapApi
      const onError = () => { this.mapa_error = true }
      const onSuccess = () => {
        if (ORDER?.status === 'ENTREGADO') {
          this.latitud = Number(ORDER.latitud)
          this.longitud = Number(ORDER.longitud)
        } else {
          this.latitud = 13.678767566370581
          this.longitud = -89.27604134734102
        }
        this.mapa_error = false
        this.initializeMap(this.latitud, this.longitud)
      }
      if (!navigator.geolocation) onError()
      else navigator.geolocation.getCurrentPosition(onSuccess, onError)
    },

    // ————————————————————————
    // Validaciones perfil
    // ————————————————————————
    updateMaskNit () {
      let value = this.nit?.replace(/\D/g, '') || ''
      let maskedValue = ''
      if (value.length > 0) {
        maskedValue += value.length > 4 ? value.substr(0, 4) + '-' : value
        maskedValue += value.length > 10 ? value.substr(4, 6) + '-' : value.substr(4)
        maskedValue += value.length > 13 ? value.substr(10, 3) + '-' : value.substr(10)
        maskedValue += value.substr(13, 1)
      }
      this.nit = maskedValue
    },
    updateMaskNrc () {
      let value = this.nrc?.replace(/\D/g, '') || ''
      let maskedValue = ''
      if (value.length > 0) {
        maskedValue += value.length > 6 ? value.substr(0, 6) + '-' : value
        maskedValue += value.substr(6, 1)
      }
      this.nrc = maskedValue
    },
    updateMaskGiro () {
      let value = this.gito?.replace(/\D/g, '') || ''
      this.gito = value
    },
    applyMask () {
      let value = (this.dui || '').replace(/\D/g, '')
      if (value.length > 9) value = value.slice(0, 9)
      if (value.length > 8) value = value.slice(0, 8) + '-' + value.slice(8)
      this.dui = value
    },
   // Reemplaza COMPLETO tu método por este:
updateMaskPhone() {
      // 1. Convertir a string y eliminar todo lo que NO sea número
      let value = String(this.mobile ?? '').replace(/\D/g, '');
      
      // 2. Si es mayor a 8 dígitos, cortar el sobrante
      if (value.length > 8) {
        value = value.slice(0, 8);
      }
      
      // 3. Asignar el valor limpio sin guiones
      this.mobile = value;
    },



    isValidDui (dui) { return /^\d{8}-\d{1}$/.test(dui) },
    isPhoneValid () { return /^[7|6|2][0-9]{7}$/.test(this.mobile) },
    isNitValid () { return /^[0-9]{4}-[0-9]{6}-[0-9]{3}-[0-9]{1}$/.test(this.nit) },
    isNRCValid () { return /^[0-9]{1,6}-[0-9]{1}$/.test(this.nrc) },

    onlyStringVarcharN () {
      const regex = /[^A-Za-záéíóúÁÉÍÓÚñÑ\s]/g
      if (regex.test(this.name)) this.name = this.name.replace(regex, '')
    },
    onlyStringVarcharS () {
      const regex = /[^A-Za-záéíóúÁÉÍÓÚñÑ\s]/g
      if (regex.test(this.surname)) this.surname = this.surname.replace(regex, '')
    },
    setEmailP () { this.email = (this.email || '').replace(/\s+/g, '') },

    async saveProfile () {
      if (this.nit && !this.isNitValid()) { this.NIT_NRC_ERROR_TEXT = 'El NIT ingresado no tiene el formato correcto'; return }
      if (this.nrc && !this.isNRCValid()) { this.NIT_NRC_ERROR_TEXT = 'El NRC ingresado no tiene el formato correcto!'; return }
      if (!this.isPhoneValid()) { this.NIT_NRC_ERROR_TEXT = 'El telefono ingresado no tiene el formato correcto!'; return }
      if (!this.isValidDui(this.dui)) { this.NIT_NRC_ERROR_TEXT = 'El DUI debe ingresarse y estar en el formato correcto'; return }
      if (!(/^[^@]+@\w+(\.\w+)+\w$/.test(this.email))) { this.NIT_NRC_ERROR_TEXT = 'Ingresa un correo válido.'; return }
      if ((this.name || '').replace(/\s+/g, '').length === 0) { this.NIT_NRC_ERROR_TEXT = 'Ingresa un nombre.'; return }
      if ((this.surname || '').replace(/\s+/g, '').length === 0) { this.NIT_NRC_ERROR_TEXT = 'Ingresa un apellido.'; return }

      const formData = new FormData()
      formData.append('name', this.name)
      if (this.surname) formData.append('surname', this.surname)
      formData.append('email', this.email)
      formData.append('dui', this.dui)
      if (this.mobile) formData.append('mobile', this.mobile)
      if (this.nit) formData.append('nit', this.nit)
      if (this.nrc) formData.append('nrc', this.nrc)
      if (this.gito) formData.append('gito', this.gito)
      if (this.departament_factura) formData.append('departament', this.departament_factura)
      if (this.municipality_factura) formData.append('municipality', this.municipality_factura)
      if (this.address_factura) formData.append('address', this.address_factura)
      if (this.photo_file) formData.append('photo_file', this.photo_file)
      if (this.birthday) formData.append('birthday', this.birthday)

      const resp = await myApi.post('ecommerce/profile', formData)
      if (resp.data.error) {
        for (const key in resp.data.error) {
          this.$notify({ title: 'VALIDACIÓN', text: resp.data.error[key], duration: 4000, type: 'error' })
        }
      } else {
        this.NIT_NRC_ERROR_TEXT = null
        this.$notify({ title: 'PERFIL DEL CLIENTE SE ACTUALIZO', duration: 3500 })
        this.showProfile(this.ordersPage)
      }
    }
  },

  created () {
    this.uniqd_parms = (this.$route.query.uniqd || this.$route.params?.uniqd || '').toString().trim() || null
    this.t_parms = (this.$route.query.t || '').toString().trim() || null
    this.perfil = Number(this.$route.query.perfil || 0)
  },

  mounted () {
    this.max_year = new Date().getFullYear() - 18
    this.BACKUP_MUNICIPIOS = SALVADOR.MUNICIPIOS
    this.S_DEPARTAMENTOS = SALVADOR.DEPARTAMENTOS

    // token invitado
    this.t_parms = (this.$route.query.t || '').toString().trim() || null

    if (store.getters.loggedIn) {
      this.isGuest = false
      this.showProfile(1) // carga perfil + órdenes (paginadas)
    } else if (this.uniqd_parms) {
      // modo invitado
      this.isGuest = true
      this.perfil = 0
      this.loadGuestOrder(this.uniqd_parms)
    } else {
      this.$router.push({ name: 'Login' })
    }

    // listeners
    this.emitter.on('review-modal-refresh', data => {
      const backup = this.order_selected
      this.order_selected = null
      setTimeout(() => {
        this.viewDetailSale(backup)
        const i = this.order_selected.items.findIndex(it => it.id === data.item.id)
        if (i !== -1) this.order_selected.items[i].review = data.review
      }, 50)
    })

    this.emitter.on('cart-shop', data => { this.CARTS = data })
  }
}
</script>



<style>
/* .t-body-orders tr:hover{
  background: #ebebeb;
} */
/* ===== Scroll horizontal SOLO para la tabla de órdenes ===== */
.items-list {
  width: 100%;
  overflow-x: auto;                 /* ← hace scroll horizontal cuando se necesita */
  -webkit-overflow-scrolling: touch;/* ← scroll suave en iOS */
}
.items-list .table.cart-table {
  min-width: 900px;                 /* ← evita que se “rompa” la tabla en pantallas pequeñas */
}

/* (Opcional) Estilo de scrollbar discreto */
.items-list::-webkit-scrollbar {
  height: 8px;
}
.items-list::-webkit-scrollbar-track {
  background: rgba(0,0,0,.08);
  border-radius: 999px;
}
.items-list::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,.25);
  border-radius: 999px;
}

/* ===== Paginación RESPONSIVE (tfoot) ===== */
.cart-table tfoot .d-flex {
  gap: .5rem;
  flex-wrap: wrap;                  /* ← permite que los elementos se acomoden en varias líneas */
  align-items: center;
  justify-content: flex-end;
}

.cart-table tfoot .btn {
  min-width: 2rem;                  /* ← botones compactos */
  padding: .25rem .5rem;
  line-height: 1.2;
}

/* Texto “Página X / Y · N órdenes” que no rompa el layout */
.cart-table tfoot .d-flex > span {
  white-space: nowrap;
  font-size: .9rem;
  opacity: .9;
}

/* En pantallas pequeñas, reduce aún más y permite partir en dos filas */
@media (max-width: 575.98px) {
  .cart-table tfoot .d-flex {
    justify-content: space-between;
  }
  .cart-table tfoot .d-flex > span {
    font-size: .85rem;
  }
}

/* ===== Paginación inferior fuera de la tabla (select de límites) ===== */
.d-flex.flex-wrap.align-items-center.justify-content-between.gap-2.mt-3 select.form-select-sm.w-auto {
  min-width: 72px;
}

/* Asegura que ese bloque también sea flexible en móvil */
.d-flex.flex-wrap.align-items-center.justify-content-between.gap-2.mt-3 {
  row-gap: .5rem;
}


.timeline li:last-child>.action {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: bold;
}

.timeline li:last-child:before {
  top: 1.825rem;
}

.timeline li:last-child:after {
  content: none;
}

.timeline li.success:before {
  background-color: #739e41;
}

.timeline li.success:not(.incompleted):after {
  background-color: #739e41;
}

.timeline li.warning:before {
  background-color: #f2a51a;
}

.timeline li.warning:not(.incompleted):after {
  background-color: #739e41;
}

.timeline li.danger:before {
  background-color: #f14c4c;
}


</style>
